import React, { Suspense, useEffect } from 'react';
import useProgressContext from 'src/hooks/useProgressContext';
import PagePreloader from 'src/components/PagePreloader';
import { Box } from '@mui/material';

const Progress = () => {
  const { setLoading } = useProgressContext();
  useEffect(() => {
    setLoading(true);
    return () => {
      setLoading(false);
    };
  });
  return (
    <Box width="100%" display="flex" justifyContent="center">
      <PagePreloader />
    </Box>
  );
};

const Loadable = (Component) => (props) => (
  <Suspense fallback={<Progress />}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
